import { render, staticRenderFns } from "./ArPrivacyPolicy.vue?vue&type=template&id=897a95c4&scoped=true"
import script from "./ArPrivacyPolicy.vue?vue&type=script&lang=js"
export * from "./ArPrivacyPolicy.vue?vue&type=script&lang=js"
function injectStyles (context) {
  
  
}

/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "897a95c4",
  null
  ,true
)

export default component.exports